import React, { Component, Fragment } from 'react';
import Navbar from '../components/Navbar';
import Calculator from '../components/Calculator';
import Breadcrumbs from '../components/Breadcrumbs';
import Image from '../components/Image';

export default class Page extends Component {
  render() {
    return (
      <Fragment>
        <title>PropertyHints: Calculate how much can you afford?</title>
        <Navbar />

        <div id="features">
          <div className="container">
            <div className="row header">
              <div className="col-md-12" align="left">
                <Breadcrumbs
                  crumbs={[
                    {
                      url: '/how-much-can-you-get',
                      name: 'How much can you get',
                    },
                  ]}
                />
                <h2 className="lead text-center">How Much Can You Get</h2>

                <div align="center">
                  <Image style={{ maxHeight: '200px' }} alt="Calculate" src="/assets/images/calculateTrimmed.jpg" />
                </div>
                <hr />
                <p>
                  Working out how much you can afford is the first thing you will need to do when you start the hunt. It
                  saves a lot of disapointment when you realise that you can't actually afford the homes you are looking
                  at
                </p>

                <p>
                  Most banks offer mortgages to people with a 20% deposit, and usually with better rates. However, most
                  will still be able to offer you a mortgage if you have less than this. Approaching a mortgage broker
                  or bank early on is a great way to see how much you actually need to have saved up
                </p>

                <p>Use the calculators below to work out what you can get</p>
                <Calculator />
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/HowMuchCanYouGet.jsx